module.exports = __webpack_public_path__ + "static/media/02-desktop-errors.4e42464a.png";